import React, { useEffect } from 'react';

export default function PanelToast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return undefined;
    const timeoutId = window.setTimeout(() => {
      onClose();
    }, toast.duration || 3200);

    return () => window.clearTimeout(timeoutId);
  }, [toast, onClose]);

  if (!toast) return null;

  return (
    <div
      className={`panel-toast panel-toast--${toast.type || 'info'}`}
      role="status"
      aria-live="polite"
    >
      <div className="panel-toast-content">{toast.message}</div>
      <button className="panel-toast-close" onClick={onClose} aria-label="Zamknij komunikat">
        ✕
      </button>
    </div>
  );
}